// 2024-05-24
// config.js
// Author: 幼稚园园长
// SoftWare: WebStorm
export default {
    "icp": "陕ICP备2020016014号-2"
}